import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./StoreLocatorOpeningStatus.module.scss";
export const shopStatus = {
    open: "open",
    closed: "closed",
    open_soon: "open_soon",
};
export const StoreLocatorOpeningStatus = ({ shopOpeningStatus, shopOpeningHours, isNewStoreCardEnabled, }) => {
    const { __ } = useTranslations();
    return (_jsxs("div", { className: styles.shopStatusWrapper, "data-testid": "attributeValuesV2", children: [_jsx("div", { className: classNames(styles.shopOpeningStatus, styles[`${shopOpeningStatus}`], {
                    [styles.locatorV2ShopOpeningStatus]: isNewStoreCardEnabled,
                    [styles.locatorV2ShopOpeningStatusFont]: isNewStoreCardEnabled,
                }), "data-testid": "shopOpeningStatus", children: __(`store_locator.popup.shop_status.${shopOpeningStatus}`) }), _jsxs("div", { className: classNames(styles.shopOpeningTimeStatus, {
                    [styles.locatorV2ShopOpeningStatusFont]: isNewStoreCardEnabled,
                }), "data-testid": "shopOpeningTimeStatus", children: [__(shopOpeningStatus === shopStatus.open
                        ? "store_locator.popup.shop_status.closesAt"
                        : "store_locator.popup.shop_status.opensAt"), " ", shopOpeningHours] })] }));
};
//# sourceMappingURL=StoreLocatorOpeningStatus.js.map